import React, { useState, useEffect } from "react";
import { FiMessageCircle, FiChevronDown, FiHeadphones } from "react-icons/fi";
import { db } from "../firebase"; 
import { ref, onValue } from "firebase/database";
import { useTranslation } from "react-i18next"; // i18n Hook added
import "./Service.css";

const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={`faq-card ${isOpen ? "active" : ""}`} onClick={() => setIsOpen(!isOpen)}>
      <div className="faq-question">
        <span>{question}</span>
        <div className={`chevron-icon ${isOpen ? "rotate" : ""}`}>
          <FiChevronDown />
        </div>
      </div>
      {isOpen && <div className="faq-answer">{answer}</div>}
    </div>
  );
};

export default function Service() {
  const { t } = useTranslation(); // Translation initialized
  const [telegramLink, setTelegramLink] = useState("https://t.me/official_support");

  useEffect(() => {
    const configRef = ref(db, 'adminConfig');
    onValue(configRef, (snapshot) => {
      const data = snapshot.val();
      if (data && data.telegram) {
        setTelegramLink(data.telegram);
      }
    });
  }, []);

  // FAQs Array integrated tightly with i18n dynamic mapping keys
  const faqs = [
    {
      question: t("What is the MALL Platform?"),
      answer: t("MALL is an intelligent cloud order matching system designed to boost sales for global e-commerce merchants while providing users with stable commission opportunities.")
    },
    {
      question: t("How long does the withdrawal take?"),
      answer: t("Generally, withdrawal requests are audited within 24 hours and transferred to your wallet shortly after approval.")
    },
    {
      question: t("What are the minimum Recharge and Withdrawal limits?"),
      answer: t("The platform requires a minimum recharge of 10 USDT, and the minimum withdrawal limit is 20 USDT.")
    },
    {
      question: t("Can I create multiple accounts?"),
      answer: t("No, each user is restricted to a single account. Creating multiple accounts may lead to account suspension to ensure platform security.")
    }
  ];

  const handleTelegramClick = () => {
    if (telegramLink) {
      window.open(telegramLink, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div className="service-page">
      <div className="service-header-bg">
        <FiHeadphones className="main-service-icon" />
        <h1>{t("Customer Service")}</h1>
        <p>{t("Available 24/7 for your support")}</p>
      </div>

      <div className="service-content">
        <div className="tg-contact-card" onClick={handleTelegramClick}>
          <div className="tg-icon-box">
            <FiMessageCircle />
          </div>
          <div className="tg-text">
            <h3>{t("Online Telegram Service")}</h3>
            <p>{t("Direct chat with official agent")}</p>
          </div>
          <button className="tg-join-btn">{t("Join Now")}</button>
        </div>

        <div className="faq-container">
          <h2 className="faq-title">{t("Frequently Asked Questions")}</h2>
          <div className="faq-list">
            {faqs.map((faq, index) => (
              <FAQItem key={index} question={faq.question} answer={faq.answer} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}